/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Forced_Subtitle_LabelInputs */



/**
* | output |
* | --- |
* | "Mark events as forced subtitle" |
*
* @param {Context_Menu_Forced_Subtitle_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_forced_subtitle_label = /** @type {((inputs?: Context_Menu_Forced_Subtitle_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Forced_Subtitle_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marquer les événements comme sous-titre forcé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse als erzwungenen Untertitel markieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contrassegna gli eventi come sottotitoli forzati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отметьте события как обязательные подзаголовки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcar eventos como subtítulos forzados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标记事件为强制字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを強制字幕としてマークする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटनाओं को अनिवार्य उपशीर्षक के रूप में चिह्नित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marque os eventos como legendas obrigatórias.")
	return /** @type {LocalizedString} */ ("Mark events as forced subtitle")
});